
import React from 'react';
import { useNavigate } from 'react-router-dom';
import "./MainCard.css";

export default function SubCard({ id, content, slug, img, title, name }) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/News/mqalat/${id}/${slug}`);
  };

  return (
    <div className="col-sm-6 mb-4">
      <div
        className="card main-card h-100"
        onClick={handleClick}
        style={{ cursor: "pointer" }}
      >
        <img
          src={img}
          className="card-img-top main-card-img"
          alt="Sub Image"
          style={{ height: '190px', objectFit: 'cover' }}
        />
        <div className="card-img-overlay d-flex flex-column justify-content-end bg-dark bg-opacity-50">
          <h6 className="card-title text-white text" style={{ lineHeight: "1.6" }}>
            {title}
          </h6>
        </div>
      </div>
    </div>
  );
}
